import axios from "axios";
import { getBaseUrl } from "../../utils/common";

// import getBaseUrl from "./analytics-url";

export default axios.create({
    baseURL: `${getBaseUrl()}/api/V1/analytics`,
    //withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});
